import * as R from 'ramda';
import ShortText from '@material-ui/icons/ShortText';
import Subject from '@material-ui/icons/Subject';
import FormatSize from '@material-ui/icons/FormatSize'
import FormatAlignJustify from '@material-ui/icons/FormatAlignJustify';
import Remove from '@material-ui/icons/Remove';
import RadioButtonChecked from '@material-ui/icons/RadioButtonChecked';
import CheckBox from '@material-ui/icons/CheckBox';
import ArrowDropDownCircle from '@material-ui/icons/ArrowDropDownCircle';
import LinearScale from '@material-ui/icons/LinearScale';
import AppsRounded from '@material-ui/icons/AppsRounded';
import Today from '@material-ui/icons/Today';
import AccessTime from '@material-ui/icons/AccessTime';
import ViewAgenda from '@material-ui/icons/ViewAgenda';

export const fields = {
    checkbox: {
        value: 'checkbox',
        label: 'Checkboxes',
        icon: CheckBox
    },
    date: {
        value: 'date',
        label: 'Date',
        icon: Today
    },
    divider: {
        value: 'divider',
        label: 'Divider',
        icon: Remove
    },
    select: {
        value: 'select',
        label: 'Dropdown',
        icon: ArrowDropDownCircle
    },
    linearScale: {
        value: 'linearScale',
        label: 'Linear Scale',
        icon: LinearScale
    },
    multipleChoice: {
        value: 'multipleChoice',
        label: 'Multiple Choice',
        icon: RadioButtonChecked
    },
    multipleChoiceGrid: {
        value: 'multipleChoiceGrid',
        label: 'Multiple choice grid',
        icon: AppsRounded
    },
    paragraph: {
        value: 'paragraph',
        label: 'Paragraph (multi-line)',
        icon: Subject
    },
    richContent: {
        value: 'richContent',
        label: 'Rich Content',
        icon: FormatAlignJustify
    },
    text: {
        value: 'text',
        label: 'Text (single-line)',
        icon: ShortText
    },
    time: {
        value: 'time',
        label: 'Time',
        icon: AccessTime
    },
    title: {
        value: 'title',
        label: 'Title and Description',
        icon: FormatSize
    },
    pageBreak: {
        value: 'pageBreak',
        label: 'Page Break',
        icon: ViewAgenda
    }
};

export const fieldNames = R.mapObjIndexed(field => field.value, fields);

export const fieldsMenuItems = [
    [
        fields.text,
        fields.paragraph
    ], [
        fields.title,
        fields.richContent,
        fields.divider
    ], [
        fields.multipleChoice,
        fields.checkbox,
        fields.select
    ], [
        fields.linearScale
    ], [
        fields.date,
        fields.time
    ], [
        fields.pageBreak
    ]
];
